function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * done
 */
import React from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { InputNumber as AntdInputNumber } from 'antd';
import { genInputNumberStyles } from "./styles";
import cx from 'classnames';
import { Text } from "../Text";
export var InputNumber = wrapReactionHook(function (props) {
  var readOnly = props.readOnly,
    maxlength = props.maxlength,
    disabled = props.disabled;
  var prefix = 'form-input-number';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genInputNumberStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  if (readOnly) {
    return /*#__PURE__*/React.createElement(Text, props);
  }
  return wrapSSR( /*#__PURE__*/React.createElement(AntdInputNumber, _extends({
    maxLength: maxlength,
    className: cx(prefix, hashId),
    disabled: disabled
  }, props)));
});